import { SwitchComponent } from './Switch.component'
import { useSwitch } from './Switch.hook'

export const Switch = {
  Root: SwitchComponent,
  Hook: useSwitch,
}
